import type { UserProfile } from "@/models/userProfile";
import axios from "axios";

export const getUserProfiles = async () : Promise<Array<UserProfile>> => {
  const response = await axios.get("/api/admin/user-profiles");
  return response.data;
}

export const getLockedUserProfiles = async() : Promise<Array<UserProfile>> => {
  const response = await axios.get("/api/admin/user-profiles/locked");
  return response.data;
}

export const getAdminUserProfiles = async() : Promise<Array<UserProfile>> => {
  const response = await axios.get("/api/admin/user-profiles/admin-users");
  return response.data;
}